import * as React from 'react';
import { List, Datagrid, TextField, DateField, SearchInput } from 'react-admin';
import { BulkActionButtons } from '../../common';

export default props => (
  <List
    {...props}
    filters={[<SearchInput source='q' alwaysOn />]}
    sort={{ field: 'id', order: 'DESC' }}
    bulkActionButtons={<BulkActionButtons resource='project' />}
    exporter={false}
  >
    <Datagrid rowClick='edit'>
      <TextField source='id' label={'ID'} />
      <TextField source='scanType' />
      <TextField source='creatorName' />
      <TextField source='projectName' />
      <TextField source='sectionName' />
      <TextField source='markCount' />
      <TextField source='deviceId' label={'Device ID'} />
      <DateField source='formCreationDate' />
    </Datagrid>
  </List>
);
